import React from 'react'
import { connect } from 'react-redux'

import SignUp from '@/components/_common/Newsletter/SignUp'
import SignUpForm from '@/components/_common/SignUpForm'
import Overlay from '@/components/Overlay'
import { fetchNewsletterData } from '@/services/contentEvents/actions'

import { HEADER_COPY, BODY_COPY, CTA_COPY } from '@/utils/content-keys'

class Newsletter extends React.Component {
	componentDidMount() {
		if (!this.props.newsletterData && !this.props.content) {
			this.props.fetchNewsletterData('Page-Component__Newsletter-Sign-Up.json')
		}
	}

	render() {
		if (!this.props.newsletterData && !this.props.content) {
			return null
		}

		const { formData, fetchData, routeProps } = this.props
		const content = this.props.content || this.props.newsletterData[0]
		const overlayId = 'Sign Up Form'

		// Format data according to older structure so SignUp and SignUpForm
		// don't need replicating/refactoring
		const signUpData = {}
		signUpData[HEADER_COPY] = {
			value: content.bannertitle
		}
		signUpData[BODY_COPY] = { value: content.bannercopy }
		signUpData[CTA_COPY] = { value: content.bannercta.bannerctatext }

		return (
			<div>
				<SignUp
					overlayId={overlayId}
					content={signUpData}
					routeProps={routeProps}
				/>
				<Overlay id={overlayId} routeProps={routeProps}>
					<SignUpForm
						data={formData}
						fetchData={fetchData}
						routeProps={routeProps}
					/>
				</Overlay>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		newsletterData: state.pageContent.newsletterData
	}
}

export default connect(
	mapStateToProps,
	{ fetchNewsletterData }
)(Newsletter)



// WEBPACK FOOTER //
// ./src/components/organisms/Newsletter/index.js